import { Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Footer from './footer/footer.component';
import Header from './header/header.component';

const PageLayout = () => {
    return (
        <Stack direction={'column'} justifyContent={'space-between'} style={{ minHeight: '100vh' }} minWidth={'1024px'}>
            <div>
                <Header />
                <div style={{ marginTop: '20px', marginLeft: '10px', marginRight: '10px', marginBottom: '10px' }}>
                    <Outlet />
                </div>
            </div>
            <Footer />
        </Stack>
    );
};

export default PageLayout;
